// src/services/adminTournaments.ts
import { httpsCallable } from 'firebase/functions';
import { functions } from '../lib/firebase';

export const cfAdminDeleteTournament = httpsCallable<
  { tournamentId: string },
  { ok: boolean }
>(functions, 'adminDeleteTournament');